import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

export default function ZonesProches() {
  const { t } = useTranslation('charny');

  const zones = [
    { label: t('zone_saint_romuald'), href: '/secteurs/saint-romuald' },
    { label: t('zone_saint_nicolas'), href: '/secteurs/saint-nicolas' },
    { label: t('zone_st_jean'), href: '#' },
    { label: t('zone_levis'), href: '#' },
  ];

  return (
    <section className="py-14 md:py-20 bg-white">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6 text-center">
        <h2 className="text-2xl md:text-3xl font-bold text-[#1B2A4E] mb-6 md:mb-8">
          {t('zones_h2')}
        </h2>

        <div className="flex flex-wrap items-center justify-center gap-3 md:gap-4">
          {zones.map((z, idx) => (
            <Link
              key={idx}
              to={z.href}
              className="inline-flex items-center gap-2 px-5 py-2.5 rounded-full border border-[#1B2A4E]/15 text-sm font-medium text-[#1B2A4E] hover:bg-[#1B2A4E] hover:text-white transition-colors whitespace-nowrap"
            >
              {z.label}
              <span className="w-4 h-4 flex items-center justify-center">
                <i className="ri-arrow-right-line text-xs" />
              </span>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}